import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface licitacion {
    codigo: string,
    nombre: string,
    ubicacion: string,
    fechaPublicacion: Date,
    fechaTermino: Date,
}

@Module
export default class LicitacionModule extends VuexModule {
  errors = {};
  licitacion = {} as licitacion;
  licitaciones = [] as Array<licitacion>;

  /**
   * Get current licitacion object
   * @returns Licitacion
   */
  get currentLicitacion(): licitacion {
    return this.licitacion;
  }

  /**
   * Get errors
   * @returns array
   */
  get getLicitacionErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_LICITACION_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_LICITACION](licitacion) {
    this.licitacion = licitacion;
  }

  @Mutation
  [Mutations.SET_LICITACIONES](groups) {
    this.licitaciones = groups;
  }

  /*@Action
  [Actions.CREATE_LICITACIONES](values) {
    return ApiService.postBlob("/Licitacion/v1/cargar/", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }*/

  @Action
  [Actions.GET_LICITACIONES]() {
    return ApiService.get(`Licitacion/v1/licitaciones`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACIONES, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.CREATE_LICITANTE](values) {
    return ApiService.post("/Licitacion/v1/cargar/licitante", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.CREATE_AYUDA](values) {
    return ApiService.postBlob("/Licitacion/v1/ayuda", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.DELETE_LICITACIONES](params) {
    return ApiService.updateBlob(`Licitacion/v1/delete/licitaciones`, params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACIONES, data);
        console.log(data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.CREATE_LICITACION](values) {
    return ApiService.postBlob("/Licitacion/v1/cargar/", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.EDIT_LICITACION](values) {
    return ApiService.putBlob("/Licitacion/v1/edit/licitacion", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.GET_LICITANTE](values) {
    return ApiService.get("/Licitacion/v1/licitante", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.GET_LICITACIONES_LICITANTE](values) {
    return ApiService.get("/Licitacion/v1/licitante/licitacion", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }


  @Action
  [Actions.UPDATE_PENDIENTE_LICITANTE](values) {
    return ApiService.put(`/Licitacion/v1/licitante/pendiente/${values}`, values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.UPDATE_RECHAZAR_LICITANTE](values) {
    return ApiService.put(`/Licitacion/v1/licitante/rechazado/${values}`, values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_LICITACION, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_LICITACION_ERROR, response.data.errors);
        throw new Error();
      });
  }

}
